module.exports = __webpack_public_path__ + "static/media/worldview6p7in.391623c3.png";